import { getCoreApiNetworkClient } from "@kunduz/data-access-core-api";
import { AxiosResponse } from "axios";
import { ILearning } from "@kunduz/data-access-learning-api";

export const useStartCourse = (
  token: string
): {
  getConsumableContent: (
    type: string,
    id: number
  ) => Promise<ILearning.LearningConsumableItem>;
  sendConsumedContent: (id: number) => void;
} => {
  const apiClient = getCoreApiNetworkClient({
    token: token,
  });

  const getConsumableContent = async (type: string, id: number) => {
    try {
      const response: AxiosResponse<ILearning.LearningConsumableItem> =
        await apiClient.get(
          `/learning/api/materials/consumable_content/?${type}=${id}`
        );

      return response.data;
    } catch (error) {
      return null;
    }
  };

  const sendConsumedContent = async (id: number) => {
    await apiClient.post(`/learning/api/materials/${id}/consumed/`);
  };

  return {
    getConsumableContent,
    sendConsumedContent,
  };
};
